import { useContext, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { TourProvider } from "./context/TourContext";
import GuidedTour from "./components/GuidedTour";
import MaintenanceBanner from "./components/MaintenanceBanner";
import Home from "./pages/Home";
import Connexion from "./pages/Connexion";
import Inscription from "./pages/Inscription";
import ForgottenPassword from "./pages/ForgottenPassword";
import ResetPassword from "./pages/ResetPassword";
import Gallery from "./pages/Gallery";
import Profile from "./pages/Profile";
import MyAlbums from "./pages/MyAlbums";
import AlbumDetail from "./pages/AlbumDetail";
import SharedWithMe from "./pages/SharedWithMe";

function RedirectToMaintenance() {
  useEffect(() => { window.location.href = '/maintenance.html'; }, []);
  return null;
}

function AppContent() {
  const { loading } = useContext(AuthContext);

  if (loading) return null;

  return (
    <>
      <GuidedTour />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/forgotten-password" element={<ForgottenPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/albums" element={<MyAlbums />} />
        <Route path="/albums/:id" element={<AlbumDetail />} />
        <Route path="/shared-with-me" element={<SharedWithMe />} />
        <Route path="/maintenance" element={<RedirectToMaintenance />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <TourProvider>
      <BrowserRouter>
        <MaintenanceBanner />
        <AppContent />
      </BrowserRouter>
    </TourProvider>
  );
}

export default App;
